import { render, staticRenderFns } from "./PieChartChannelsSales.vue?vue&type=template&id=8486dec4&"
import script from "./PieChartChannelsSales.vue?vue&type=script&lang=js&"
export * from "./PieChartChannelsSales.vue?vue&type=script&lang=js&"
import style0 from "./PieChartChannelsSales.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports